// export const NODE_ENV = "DEV"
export const NODE_ENV = "PROD"
//export const SERVER_URL = 'http://localhost:5000'
export const SERVER_URL = "https://my-portfolio-hdfd.onrender.com"
export const CLIENT_URL = "https://www.shubhamm.in"
export const SOCIAL = {
	LINKEDIN: "https://www.linkedin.com/in/kumarsks619",
	GITHUB: "https://github.com/kumarsks619",
	INSTAGRAM: "https://www.instagram.com/blck_tie",
	X: "https://x.com/kumarsks619",
}
export const SLIDESHOW_AUTO_INTERVAL_IN_MILLISECONDS = 10000
